'use strict';
import React from 'react';
import NavBar from '../../components/navBar';
import SideMenu from '../../components/sideMenu';
import Loading from '../../components/loading';
import condoSetAction from '../../actions/condoSetAction';
import condoSetStore from '../../stores/condoSetStore';
import menuAction from '../../actions/menuAction';
import ModalCheckList from './modalCheckList';
import ModalUpdated from './modalUpdated';

class CheckListForm extends React.Component {
    constructor(props) {
        super(props);
        this.handleToggle = this.handleToggle.bind(this);
        this.handleRemoveFacility = this.handleRemoveFacility.bind(this);
        this.handleEditCategory = this.handleEditCategory.bind(this);
        this.handleNewFacility = this.handleNewFacility.bind(this);
        this.onChange = this.onChange.bind(this);
        this.shouldModalClose = this.shouldModalClose.bind(this);
        this.shouldUpdateModalClose = this.shouldUpdateModalClose.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.callBack = this.callBack.bind(this);
        this.state = {
            modalClose: false,
            modalUpdateClose: false,
            action: "",
            title: "",
            index: "",
            processing: condoSetStore.getState().processing,
            checkList: condoSetStore.getState().checkList,
            isCLUpdate: condoSetStore.getState().isCLUpdate,
        };
    }
    componentDidMount() {
        condoSetStore.listen(this.onChange);
        condoSetAction.clear();
        menuAction.pageNumber(12);
        //load checkList
        if (!this.state.processing) {
            condoSetAction.processing(true);
            condoSetAction.getCheckList();
        }
    }
    componentWillUnmount() {
        condoSetStore.unlisten(this.onChange);
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.state.isCLUpdate != prevState.isCLUpdate && this.state.isCLUpdate) {
            this.setState({ title: "SuccessFul", modalUpdateClose: true });
        }
    }
    onChange(state) {
        this.setState({
            checkList: state.checkList,
            isCLUpdate: state.isCLUpdate,
            processing: state.processing,
        });
    }
    handleToggle(e) {
        let index = parseInt(e.currentTarget.getAttribute('data-index'));
        condoSetAction.shouldListShowCL2(index);
    }
    handleRemoveFacility(e) {
        e.preventDefault();
        e.stopPropagation();
        let index = parseInt(e.target.getAttribute('data-index'));
        let title = "Remove " + this.state.checkList[index].facility;
        let action = 0;

        this.setState({ title: title, action: action, index: index, modalClose: true });
    }
    handleEditCategory(e) {
        let index = parseInt(e.target.getAttribute('data-index'));
        let title = "Edit " + this.state.checkList[index].facility;
        let action = 1;

        this.setState({ title: title, action: action, index: index, modalClose: true });
    }
    handleNewFacility() {
        let title = "Add New Facility";
        let action = 2;

        this.setState({ title: title, action: action, modalClose: true });
    }
    handleClick() {
        if (this.state.processing) return;

        condoSetAction.processing(true);
        condoSetAction.updateCheckList(this.state.checkList);

    }
    shouldModalClose(data) {
        this.setState({
            modalClose: data
        });
    }
    shouldUpdateModalClose(data) {
        this.setState({
            modalUpdateClose: data
        });
        condoSetAction.isCLUpdate(false);
    }
    callBack(cl, nf) {
        if (this.state.action == 1) {
            condoSetAction.checkList(cl);
        } else if (this.state.action == 0) {

            let checkList = this.state.checkList;
            //remove from database
            if (checkList[this.state.index]._id) {
                condoSetAction.removeCheckList(checkList[this.state.index]._id);
            }
            //remove from checklist
            checkList.splice(this.state.index, 1);
            condoSetAction.checkList(checkList);


        } else if (this.state.action == 2) {
            let checkList = this.state.checkList;

            //update checklist
            checkList.push({
                facility: nf,
                categories: [],
            });
        } else if (this.state.action == 3) {
            condoSetAction.isCLUpdate(false);
        }
        this.shouldModalClose(false);
    }
    renderDes(description) {
        if (!description) return;
        return description.map((des, index) => {
            return (
                <li className="cl-ol-li" key={index}>
                    {des}
                </li>
            );
        });
    }
    renderCategory(checkList) {
        if (!checkList.categories) return;
        return checkList.categories.map((ct, index) => {
            return (
                <div key={index}>
                    <div className="cl-ct-tt">{ct.category}</div>
                    <ol className="cl-ol">
                        {this.renderDes(ct.description)}
                    </ol>
                </div>
            );
        })
    }
    renderFacility(checkList, index) {
        return (
            <li className="cl-li-1" key={index}>
                <div className="cl-tt" data-index={index} onClick={this.handleToggle}>
                    <span className={"cl-icon glyphicon " + (checkList.shouldListShow ? "glyphicon-minus" : "glyphicon-plus")}></span>
                    {checkList.facility}
                    <div className="ct-btn-grp">
                        <button className="btn btn-xs btn-danger" data-index={index} onClick={this.handleRemoveFacility}>Remove</button>
                    </div>
                </div>
                <div className={"cl-ct " + (checkList.shouldListShow ? "ct-show" : "ct-hide")}>
                    <button className="cl-li-edit btn btn-default btn-xs" data-index={index} onClick={this.handleEditCategory}>Edit</button>
                    <h5><b>Category</b></h5>
                    {this.renderCategory(checkList)}
                </div>
            </li>
        )
    }
    renderCheckList() {
        let s = this.state;
        let checkList = s.checkList.map((checkList, index) => {
            return this.renderFacility(checkList, index);
        });

        return (
            <ul className="cl-fc" >
                {checkList}
            </ul>
        )
    }
    render() {
        let modal = "";
        if (this.state.modalClose) {
            modal = (
                <ModalCheckList
                    checkList={this.state.checkList}
                    modalClose={this.state.modalClose}
                    shouldModalClose={this.shouldModalClose}
                    action={this.state.action}
                    title={this.state.title}
                    index={this.state.index}
                    callBack={this.callBack}
                    editCheckList={this.state.editCheckList}
                    newFacility={this.state.newFacility}
                />
            );
        }
        return (
            <div className="container-fluid content">
                <div className="row">
                    <NavBar {...this.props} />
                    <SideMenu {...this.props} />
                    <Loading {...this.props} processing={this.state.processing} />
                    <div className=" col-md-10  col-sm-8 us-form">
                        <div className="checkList-form">
                            <div className="row">
                                <div className="col-md-8">
                                    <h4><b>Master Check List</b></h4>
                                    <button type="button" className="btn btn-warning"
                                        data-index="0" onClick={this.handleNewFacility}>Add Facility</button>
                                    {this.renderCheckList()}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-4">
                                    <button type="button" className="btn btn-warning us-cr"
                                        data-index="0" onClick={this.handleClick}>Update</button>
                                </div>
                                <div className="clear"></div>
                            </div>
                            {modal}
                            <ModalUpdated shouldModalClose={this.shouldUpdateModalClose} modalClose={this.state.modalUpdateClose} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default CheckListForm;


// WEBPACK FOOTER //
// ./app/setComponents/condoSetComponents/checkListForm.js